import { Check, Loader2 } from "lucide-react";

import { useUpdateOrderStatus } from "@/api/order-query";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { OrderStatusEnum } from "@/types/order";

export function AcceptOrder({ orderId, onSuccess }: { orderId: string; onSuccess: () => void }) {
	const updateOrderStatus = useUpdateOrderStatus();

	return (
		<Dialog onOpenChange={open => open && !updateOrderStatus.isSuccess}>
			<DialogTrigger asChild>
				<Button>Accept this order</Button>
			</DialogTrigger>
			<DialogTitle className="sr-only">Reject Order</DialogTitle>
			<DialogDescription className="sr-only">
				Reject an order from a a vendor
			</DialogDescription>
			<DialogContent className="gap-1">
				{updateOrderStatus.isSuccess
					? (
							<div className="grid place-content-center gap-4 py-4">
								<div className="size-20 bg-hover-secondary rounded-full p-2 grid place-content-center text-white">
									<div className="size-16 bg-primary rounded-full p-2 grid place-content-center text-white text-2xl">
										<Check />
									</div>
								</div>
							</div>
						)
					: (
							<div className="grid place-content-center gap-4 py-4">
								<div className="size-20 bg-hover-secondary rounded-full p-2 grid place-content-center text-white">
									<div className="size-16 bg-primary rounded-full p-2 grid place-content-center text-white text-2xl">
										!
									</div>
								</div>
							</div>
						)}
				<div>
					<p className="font-bold text-center text-xl">Confirm Order</p>
					<p className="text-center">
						{updateOrderStatus.isSuccess
							? "You have just accepted this order"
							: "Confirm that you want to accept this order"}
					</p>
				</div>

				<DialogFooter className="mt-6">
					<DialogTrigger asChild>
						<Button variant="secondary" className="w-full">
							Cancel
						</Button>
					</DialogTrigger>
					<Button
						onClick={() => {
							updateOrderStatus.mutateAsync({
								orderId,
								status: OrderStatusEnum.COMPLETED
							}).then(() => {
								onSuccess();
							});
						}}
						disabled={updateOrderStatus.isPending}
					>
						{updateOrderStatus.isPending
							? (
									<>
										<Loader2 size={20} className="animate-spin" />
										{" "}
										Loading....
									</>
								)
							: (
									"Yes, I want to accept this order"
								)}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
